import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'es6-promise/auto';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'ol/ol.css'

Vue.config.devtools = true;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
